import logo from './images/quyvaLogo.png';

// App info.
export const appName = 'Quyva';
export const appLogo = logo;
export const appVersion = '1.0.0';
export const companyNumber = '+91 - 120 - 4254108';
export const companyEmail = 'info@mtree.co.in';
export const companyDomain = 'https://quyva.mtree.co.in/';
